// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d456ce70","455":"8dd5ea57","977":"48858afe"}[chunkId] + ".chunk.js";
};